module.exports = __webpack_public_path__ + "img/1920_stores_img5.763443ed.png";